import React, { useRef } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Badge,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import {
  addUploadRecordHeader,
  downloadZipFileForHeader,
  fetchDocumentCategoryList,
  getDownloadFileForPopUpDetails,
  getRecordHeaderdetails,
  updateUploadRecordHeader,
} from "../../../../services/UploadRecordsApi";
import TextInput from "../../../../common/TextInput";
import EditableFileTable from "../../../../common/RecordFileUploadDataTable";
import Snackbar from "../../../../common/Snackbar";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import { GENERAL_LOG_HEADERS } from "../../Case_Information/actions/Constant";
import moment from "moment";
import Loader from "../../../../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import AccordionComponent from "../../../../common/Accordion";
import { fetchPartiesDetails } from "../../../../services/CaseInformationApi";
import {
  setIsUploadFile,
  setIsCancelFiles,
  setRecordAvailable,
} from "../../../../redux/slice/CaseHeaderSlice";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import { useIsStageReadOnly } from "../../../../utils/caseStageChecker";
import { ROR_STATUS, TRANSCRIPTION_REPORT_STATUS, WEB_ROLE } from "../../../../common/Constant";
import { getAppointmentListByCase, getAppointmentListByDocumentTypeCase, getQMEProcessStatus } from "../../../../services/ScheduleAppointmentApi";
import { GetReviewerRecordList, GetReviewerRecordSummaryList, GetReviewerRORStatusUpdateList, getRORNewPagesEmail } from "../../../../services/RecordReviewerAPI";
import RORDataTable from "../../../ToDos/RecordReviewer/components/RecordReviewerUploadRecord/RORDataTable";
import { REVIEW_RECORD_HEADERS } from "../../../ToDos/RecordReviewer/actions/constants";
import UploadStatusFloatingIcon from "../../../../common/UploadStatusFloatingIcon";

interface SelectedRowData {
  actions: { Edit: string };
  additionalComments: string;
  caseInfoId: number;
  caseRecordHeaderId: number;
  documentCategory: string;
  documentTypeId: number;
  documentTypeName: string;
  fileAction: number;
  headerCreatedBy: string;
  headerCreatedDate: string;
  headerModifiedByName: string;
  headerUpdatedDate: string;
  responseCode: number;
  responseMessage: string;
  totalNoOfFiles: number;
}

interface UploadRecordProps {
  caseInfoId: number;
  userData: any;
  loggedInUserid: number | null;
  onCancel: (action: string) => void;
  selectedRowData: SelectedRowData | null;
  onTabChange: any;
  recordActiveTab: string;
  isRowActionTriggered: boolean;
  activeTab: string;
  isEditorFile?: boolean;
}

interface PartyOption {
  value: string;
  label: string;
  partyCode: string;
}

const NON_CASE_RELATED_DOCS = new Set([
  "Interpreter Certification",
  "110 Form (QME Appointment Notification)",
  "Proof of Service / Declaration of Service",
  "Injured Worker History Report",
  "Record Review Summary",
  "DWC Extension",
  "Billing Invoices",
  "Correspondence Logs",
  "Notes Attachment",
  "SIBTF Report",
  "Other",
]);

const QME_DOCUMENT_TYPES = [
  "Transcription",
  "Draft Transcription",
  "Record Review Summary",
];

const DISABLED_ROR_STATUSES = [
  ROR_STATUS.REVIEW_COMPLETED,
  ROR_STATUS.Review_Completed_Delayed
];

const UploadRecords: React.FC<UploadRecordProps> = ({
  caseInfoId,
  userData,
  loggedInUserid,
  selectedRowData,
  isRowActionTriggered,
  onCancel,
  recordActiveTab,
  activeTab,
  onTabChange,
  isEditorFile = false,
}) => {
  const dispatchNew = useDispatch<AppDispatch>();
  const { view_Case, currentUserRoleApp } = useSelector((state: RootState) => state.featureAccess);

  const isStageNonEditable = useIsStageReadOnly();
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    {
      value: string | number;
      label: string;
      documentCategory: string;
      documentTypeDescription: string;
    }[]
  >([]);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null,
  );
  const [documentTypeName, setDocumentTypeName] = useState<string>("");
  const [senderName, setSenderName] = useState<string>("");
  const [documentCategory, setDocumentCategory] = useState<string>("");
  const [documentTypeDescription, setDocumentTypeDescription] =
    useState<string>("");
  const [senderOptions, setSenderOptions] = useState<PartyOption[]>([]);
  const [sender, setSender] = useState<string | null | number>(null);
  const [senderCode, setSenderCode] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [provisionalIdsNew, setProvisionalIdsNew] = useState<any>([]);
  const [result, setResult] = useState<any>({});
  const [logdata, setLogdata] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [isOnSaveDisable, setIsOnSaveDisable] = useState<boolean>(false);
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean | undefined>(
    false,
  );
  const [parentCaseRecordDetailsId, setParentCaseRecordDetailsId] = useState<
    null | number
  >(null);

  const { isUploadFile, isRecordAvailable } = useSelector((state: RootState) => state.caseHeader);
  const dispatch = useDispatch();
  const [isAllCancel, setIsAllCancel] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const cancelButtonRef = useRef<HTMLButtonElement>(null);
  const [appointmentDateTime, setAppointmentDateTime] = useState<
    string | null | number
  >(null);
  const [appointmentDateOptions, setAppointmentDateOptions] = useState<any[]>(
    [],
  );
  const [showUploadWarning, setShowUploadWarning] = useState(false);
  const [recordInfoKey, setrecordInfoKey] = useState<string | null>("0");
  const [documentName, setDocumentName] = useState("");
  const [reviewRecordSummaryResult, setReviewRecordSummaryResult] = useState<
    any[]
  >([]);
  const [recordLists, setRecordLists] = useState<{ [key: string]: any[] }>();
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});
  const [selectedRowsByCategory, setSelectedRowsByCategory] = useState<{
    [category: string]: any[];
  }>({});
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const userRole = currentUserRoleApp || localStorage.getItem("userrole") || "";
  const roles = userRole ? userRole?.split(",").map((r) => r.trim()) : [];
  const isQMEDoctorAllowEdit = selectedRowData?.headerCreatedBy
    ? Number(loggedInUserid) === Number(selectedRowData?.headerCreatedBy)
    : false;
  const isQMEDoctor = roles.includes(WEB_ROLE.QME_Doctor);
  const isEditor = roles.includes(WEB_ROLE.Editor);
  const isBillingSpecialist = roles.includes(WEB_ROLE.Billing_Specialist);
  const isEditorOrBillingRole = isEditor || isBillingSpecialist;

  const isRestirctEdit = selectedRowData?.headerCreatedBy
    ? isQMEDoctorAllowEdit && isQMEDoctor
    : isQMEDoctor;

  const safeApiCall = async (
    apiCall: Promise<any>,
    onSuccess: (data: any) => void,
  ) => {
    try {
      const res = await apiCall;
      onSuccess(res);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    if (
      recordActiveTab === "Upload Records" &&
      !selectedRowData?.caseRecordHeaderId
    ) {
      const handleParties = (partiesList: any[]) => {
        setSenderOptions(partiesList || []);

        const selectedParty = partiesList?.find(
          (item: any) => item.value === String(loggedInUserid),
        );

        if (selectedParty && isEditorFile) {
          setSender(selectedParty.value || null);
          setSenderCode(selectedParty?.partyCode || "");
        }
      };

      safeApiCall(fetchDocumentCategoryList(), (data) =>
        setDocumentTypeOptions(
          (data || [])?.filter(
            (item: any) => item.label?.toLowerCase() !== "notes attachment",
          ),
        ),
      );

      safeApiCall(fetchPartiesDetails(caseInfoId), handleParties);
    }
  }, [recordActiveTab]);

  const fetchAppointmentDatesByDocumentType = async (
    caseId: number,
    documentTypeId: number
  ) => {
    try {
      const data = await getAppointmentListByDocumentTypeCase(
        caseId,
        documentTypeId
      );

      return data ?? [];
    } catch (error) {
      console.error("Error fetching appointment dates:", error);
      return [];
    }
  };

  const fetchQMEProcessData = async (id: number) => {
    try {
      const data = await getQMEProcessStatus(id);

      const isReviewCompleted = [
        ROR_STATUS.REVIEW_COMPLETED,
        ROR_STATUS.Review_Completed_Delayed
      ].includes(data?.rorStatusName);

      const isTranscriptionCompleted = data?.transcriberStatusName === TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED;

      let message = "";

      if (isReviewCompleted && documentName === "Record Review Summary") {
        message =
          "Final Record Review Summary already uploaded for this appointment. Upload is not allowed.";
      } else if (isTranscriptionCompleted && (documentName === "Draft Transcription" || documentName === "Transcription")) {
        message =
          "Final transcription already uploaded for this appointment. Upload is not allowed.";
      }

      if (message) {
        setSnackbarMessage(message);
        setSnackbarOpen(true);
        setError("error");
        setAppointmentDateTime(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const fetchHeaderData = async () => {
    try {
      setIsOnSaveDisable(false);
      if (selectedRowData?.caseRecordHeaderId) {
        setLoading(true);
        const data = await getRecordHeaderdetails(
          selectedRowData?.caseRecordHeaderId,
        );

        const firstRecord = data?.result?.[0];
        if (firstRecord) {
          const appointmentOptions = await getAppointmentListByCase(caseInfoId);
          setAppointmentDateOptions(appointmentOptions ?? []);
          
          const isDocTypeMissing =
            !!firstRecord.documentTypeId &&
            !documentTypeOptions.some(
              (opt) => opt.value === String(firstRecord.documentTypeId),
            );

          const isSenderMissing =
            !!firstRecord.senderKeyId &&
            !senderOptions.some(
              (opt) => opt.value === String(firstRecord.senderKeyId),
            );

          if (isDocTypeMissing) {
            setDocumentTypeOptions((prev) => [
              ...prev,
              {
                value: Number(firstRecord.documentTypeId),
                label: firstRecord.documentTypeName || "",
                documentCategory: firstRecord.documentCategory || "",
                documentTypeDescription:
                  firstRecord.documentTypeDescription || "",
              },
            ]);
          }
          if (isSenderMissing) {
            setSenderOptions((prev) => [
              ...prev,
              {
                value: String(firstRecord.senderKeyId),
                label: firstRecord.senderKeyName || "",
                partyCode: firstRecord.senderKeyCode || "",
              },
            ]);
          }
          setDocumentType(firstRecord.documentTypeId || null);
          setDocumentTypeName(firstRecord.documentTypeName || "");
          setDocumentCategory(firstRecord.documentCategory || "");
          setSenderName(firstRecord.senderKeyName || "");
          setAppointmentDateTime(
            String(firstRecord?.subjectQMEScheduleID) || null,
          );
          setSender(String(firstRecord.senderKeyId) || null);
          setSenderCode(firstRecord.senderKeyCode || "");
          setDocumentTypeDescription(firstRecord.documentTypeDescription || "");
          setParentCaseRecordDetailsId(firstRecord.parentCaseRecordDetailsId);
          setComments(firstRecord.additionalComments || "");
          setResult(data?.result || {});
          setLogdata([
            {
              createdDate: moment(firstRecord.headerCreatedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              modifiedDate: moment(firstRecord.headerModifiedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              createdByName: firstRecord.headerCreatedByName,
              modifiedByName: firstRecord.headerModifiedByName,
            },
          ]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isRowActionTriggered) {
      resetData();
    }
  }, [recordActiveTab, activeTab]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      fetchHeaderData();
    }
  }, [selectedRowData]);

  const existsDocType =
    !!selectedRowData?.caseRecordHeaderId &&
    !!documentType &&
    !documentTypeOptions?.some((opt) => opt.value === documentType);

  const resetData = () => {
    const selectedAppointment =
      appointmentDateOptions && appointmentDateOptions?.length > 0
        ? appointmentDateOptions[0]?.value
        : null;
    setAppointmentDateTime(null);
    setDocumentType(null);
    setDocumentCategory("");
    setSender(null);
    setSenderCode("");
    setDocumentTypeDescription("");
    setComments("");
    setFileIds([]);
    setProvisionalIdsNew([]);
    setParentCaseRecordDetailsId(null);
    setResult({});
  };

  const validateForm = () => {
    const errors = [];

    if (!documentType) {
      errors.push("Document Type is mandatory.");
    }

    if (!sender) {
      errors.push("Sender is mandatory.");
    }

    if (!appointmentDateTime) {
      errors.push("Appointment Date & Time is mandatory.");
    }

    if (documentType && !fileIds?.length) {
      errors.push("Please add at least one record.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsOnSaveDisable(true);
    setLoading(true);
    const existCaseRecordHeaderId = selectedRowData?.caseRecordHeaderId;
    let caseRecordDetailsIDs = "";
    let pagesReviewedValues = "";
    
    if (documentName === "Record Review Summary") {
      const allSelectedRows = Object.values(selectedRowsByCategory).flat();
      caseRecordDetailsIDs = allSelectedRows
        ?.map((row) => row.caseRecordDetailsID)
        ?.filter((id) => id != null && id !== "")
        .join(",");

      pagesReviewedValues = allSelectedRows
        ?.map((row) => row.pagesReviewed || 0)
        .join(",");
    }

    const payloadAdd = {
      caseInfoId: caseInfoId,
      documentTypeId: Number(documentType) || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: fileIds.join(", ") || "",
      senderKeyId: Number(sender) || null,
      subjectQmeScheduleId: Number(appointmentDateTime) || null,
      senderKeyCode: senderCode || "",
      createdBy: loggedInUserid,
      ...(documentName === "Record Review Summary" && {
        caseRecordDetails_Csv: caseRecordDetailsIDs || "",
        pageReviewed_Csv: pagesReviewedValues || "",
        detailsComments_Csv: "",
      }),
    };

    const payloadUpdate = {
      caseRecordHeaderId: selectedRowData?.caseRecordHeaderId,
      caseInfoId: caseInfoId,
      documentTypeId: Number(documentType) || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: provisionalIdsNew || "",
      senderKeyId: Number(sender) || null,
      subjectQmeScheduleId: Number(appointmentDateTime) || null,
      senderKeyCode: senderCode || "",
      createdBy: loggedInUserid,
      modifiedBy: loggedInUserid,
      ...(documentName === "Record Review Summary" && {
        caseRecordDetails_Csv: caseRecordDetailsIDs || "",
        pageReviewed_Csv: pagesReviewedValues || "",
        detailsComments_Csv: "",
      }),
    };

    try {
      let response;
      if (existCaseRecordHeaderId) {
        // Update existing records
        response = await updateUploadRecordHeader(payloadUpdate);
      } else {
        // Create new records
        response = await addUploadRecordHeader(payloadAdd);
      }

      if (response?.isSuccess) {
        setSnackbarMessage(
          existCaseRecordHeaderId
            ? "Records updated successfully."
            : "Records added successfully.",
        );
        setError("success");

        const normalizedDocumentName = documentName?.trim();

        if (
          normalizedDocumentName &&
          !NON_CASE_RELATED_DOCS.has(normalizedDocumentName)
        ) {
          await getRORNewPagesEmail(Number(appointmentDateTime));
        }

        setSnackbarOpen(true);
        if(!existCaseRecordHeaderId && !isRecordAvailable){
          dispatchNew(setRecordAvailable(true));
        }
        dispatchNew(fetchCaseStages(caseInfoId));
        setTimeout(() => {
          onTabChange();
        }, 1000);
      } else {
        setSnackbarMessage(response?.message || "Failed to process record.");
        setError("error");
        setSnackbarOpen(true);
        setIsOnSaveDisable(false);
      }
    } catch (error) {
      console.error("Error processing record:", error);
      setSnackbarMessage("An error occurred while processing the record.");
      setSnackbarOpen(true);
      setError("error");
      setIsOnSaveDisable(false);
    } finally {
      setLoading(false);
      setIsOnSaveDisable(false);
    }
  };

  const handleFileIdsUpdate = (
    ids: string[],
    isSaveDisabled?: boolean,
    fileActions?: any,
  ) => {
    setProvisionalIdsNew(fileActions);
    setFileIds(ids);
    setIsSaveDisabled(isSaveDisabled);
  };

  const handleBack = () => {
    if (isUploadFile) {
      setShowUploadWarning(true);
    } else {
      setShowUploadWarning(false);
      onCancel("Cancel");
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = async () => {
    setIsCancel(true);
    if (selectedRowData?.caseRecordHeaderId) {
      await fetchHeaderData();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const handleSaveStateChange = (disabled: boolean) => {
    setIsSaveDisabled(disabled);
  };

  useEffect(() => {
    if (documentType) {
      const found = documentTypeOptions.find(
        (doc) => doc.value === documentType,
      );
      if (found) {
        setDocumentName(found.label);
      }
    }
  }, [documentType]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
      setDocumentName("");
    }
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  const lastOpenedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!documentType && !sender) return;

    const handleScroll = () => {
      if (lastOpenedRef.current && Date.now() - lastOpenedRef.current < 300) {
        return;
      }

      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  const recordInfoAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          recordInfoKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}{" "}
              <span className="fw-normal">
                {existsDocType
                  ? documentTypeName && ` - ${documentTypeName} `
                  : documentName && ` - ${documentName} `}
              </span>
            </>
          ),
      }))}
      activeKey={recordInfoKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now();
        setrecordInfoKey(key as string);
      }}
    />
  );

  const [attachmentKey, setattachmentKey] = useState<string | null>("0");
  const [rorKey, seRORKey] = useState<string | null>("0");

  const attachmentAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={attachmentKey}
      onSelect={(key) => setattachmentKey(key as string)}
    />
  );

  const recordRORAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={rorKey}
      onSelect={(key) => {
        seRORKey(key as string);
      }}
    />
  );

  const fetchRORListData = async () => {
    try {
      const reviewRecordSummaryData = await GetReviewerRecordSummaryList(
        caseInfoId,
        Number(appointmentDateTime)
      );

      const resultList = reviewRecordSummaryData?.result ?? [];
      setReviewRecordSummaryResult(resultList);
      
      if (resultList?.length > 0) {
        const allKeys = resultList.map((_, index) => index.toString());
        setActiveKeys(allKeys);

        const recordListPromises = resultList.map((item) =>
          GetReviewerRecordList(
            caseInfoId,
            Number(item.keyID),
            Number(appointmentDateTime)
          ).then((res) => ({
            category: item.dataCategory,
            data: res?.result || [],
          }))
        );

        const allRecordLists = await Promise.all(recordListPromises);
        const recordMap: Record<string, any[]> = {};
        allRecordLists.forEach(({ category, data }) => {
          recordMap[category] = data;
        });

        setRecordLists(recordMap);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchRecordListDataNew = async (
    caseInfoId: number,
    KeyId: number,
    dataCategory: string,
  ) => {
    try {
      const listData = await GetReviewerRecordList(
        caseInfoId,
        KeyId,
        Number(appointmentDateTime),
      );
      setRecordLists((prev) => ({
        ...prev,
        [dataCategory]: listData?.result || [],
      }));
    } catch (error) {
      console.error("Error fetching record list data:", error);
    }
  };

  useEffect(() => {
    if (documentName === "Record Review Summary" && appointmentDateTime) {
      fetchRORListData();
    }
  }, [documentName, appointmentDateTime]);

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip"
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleHeaderFileDownloadAction = async (
    datacategory: string,
    keyID: any,
  ) => {
    const listDataNew = await GetReviewerRecordList(
      caseInfoId,
      keyID,
      Number(appointmentDateTime),
    );
    const newIDs =
      listDataNew?.result?.map((item) => item.caseRecordHeaderID).join(",") ||
      "";

    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(newIDs, 1, ""),
    );
  };
  
  const handleDownloadSingleFile = (row: any) => {
    handleDownloadProgress(`popup-${Date.now()}`, () =>
      getDownloadFileForPopUpDetails(row?.caseRecordDetailsID, row?.fileName)
    );
  };

  const handlePagesReviewedChange = (rows: any[], category?: string) => {
    if (category) {
      setSelectedRowsByCategory((prev) => ({
        ...prev,
        [category]: rows,
      }));
    }
  };

  const handleCheckboxSelect = (category: string, selectedRows: any[]) => {
    setSelectedRowsByCategory((prev) => ({
      ...prev,
      [category]: selectedRows,
    }));
  };

  const isTranscriptionCompleted = (documentName === "Draft Transcription" || documentName === "Transcription") &&
    result?.[0]?.transcriberStatus === TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED;

  const isRORCompleted = documentName === "Record Review Summary" && DISABLED_ROR_STATUSES.includes(result?.[0]?.rorStatus);

  const renderAccordion = () => (
    <AccordionComponent
      items={reviewRecordSummaryResult.map(
        (
          {
            dataCategory,
            totalRecords,
            lastUploadedBy,
            lastUploadedOn,
            keyID,
            categoryWiseTotalPageCount,
          },
          index,
        ) => ({
          title: (
            <div className="d-flex align-items-center w-100">
              <div className="me-auto d-flex align-items-center w-60">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{dataCategory}</Tooltip>}
                >
                  <span className="text-truncate w-50">{dataCategory} </span>
                </OverlayTrigger>

                <Badge bg="primary" className="ms-2 primary-badge ">
                  {totalRecords}
                </Badge>
                {categoryWiseTotalPageCount != null && (
                  <>
                    <span className="ms-3 material-icons theme-color">
                      auto_stories
                    </span>
                    <span
                      className="ms-1 theme-color mx-1 fw-light"
                      style={{ width: "55px", textAlign: "left" }}
                    >
                      Pages -{" "}
                    </span>
                    <span className="text-muted">
                      {categoryWiseTotalPageCount}
                    </span>
                  </>
                )}
              </div>
              <div className="fw-normal accord-righttext me-3">
                <div className="d-flex align-items-center justify-content-end">
                  <span
                    className="me-2"
                    style={{ width: "100%", display: "inline-flex" }}
                  >
                    <span
                      style={{
                        width: "81%",
                        marginTop: "5px",
                        display: "inline-block",
                        textAlign: "right",
                        paddingRight: "10px",
                      }}
                    >
                      Last Uploaded On:{" "}
                      {new Date(lastUploadedOn).toLocaleDateString(
                        "en-US",
                      )}{" "}
                    </span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{lastUploadedBy}</Tooltip>}
                    >
                      <span
                        className="theme-color text-truncate"
                        style={{
                          width: "50%",
                          float: "right",
                          marginTop: "5px",
                        }}
                      >
                        {" "}
                        | {lastUploadedBy}{" "}
                      </span>
                    </OverlayTrigger>
                  </span>
                  <Button
                    variant="primary"
                    size="sm"
                    className="d-flex align-items-center me-2 px-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleHeaderFileDownloadAction(dataCategory, keyID);
                    }}
                  >
                    <span className="material-icons">download</span>
                  </Button>
                </div>
              </div>
            </div>
          ),
          content: (
            <>
              <div>
                {recordLists?.[dataCategory]?.length ? (
                  <RORDataTable
                    key={`table-${dataCategory}-${index}`}
                    headers={REVIEW_RECORD_HEADERS}
                    rows={recordLists[dataCategory] || []}
                    isCheckbox={true}
                    onDownloadAction={handleDownloadSingleFile}
                    onPagesReviewedChange={(rows) =>
                      handlePagesReviewedChange(rows, dataCategory)
                    }
                    selectedRowIds={
                      selectedRowsByCategory[dataCategory]?.map((r) => r.id) ||
                      []
                    }
                    onCheckboxSelect={(rows) =>
                      handleCheckboxSelect(dataCategory, rows)
                    }
                    isRORCompletedWithStatus={
                      (view_Case &&
                        !isRestirctEdit &&
                        !isEditorOrBillingRole) ||
                      isStageNonEditable || 
                      isRORCompleted || isTranscriptionCompleted 
                    }
                  />
                ) : (
                  <div>
                    <Row>
                      <span className="no_rec_data">No Record Found</span>
                    </Row>
                  </div>
                )}
              </div>
            </>
          ),
          eventKey: index.toString(),
        }),
      )}
      activeKey={activeKeys}
      onSelect={(key) => {
        const index = parseInt(key || "0");
        const { dataCategory, keyID } = reviewRecordSummaryResult[index];
        handleAccordionToggle(key, dataCategory, keyID);
      }}
      isROR={true}
    />
  );

  const handleAccordionToggle = async (
    key: string | null,
    dataCategory: string,
    KeyID: number,
  ) => {
    if (!key) return;
    setActiveKeys((prevActiveKeys = []) => {
      if (prevActiveKeys.includes(key)) {
        return prevActiveKeys.filter((k) => k !== key);
      }

      return [...prevActiveKeys, key];
    });
    await fetchRecordListDataNew(caseInfoId, KeyID, dataCategory);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isUploadFile) return;
      const target = event.target as HTMLElement;
      // Check if the element or its parent has a "pointer" cursor
      const hasPointerCursor = (element: HTMLElement | null): boolean => {
        while (element) {
          const style = window.getComputedStyle(element);
          if (style.cursor === "pointer") return true;
          element = element.parentElement;
        }
        return false;
      };

      const isButton =
        target.tagName === "BUTTON" ||
        target.closest("button") ||
        target.classList.contains("btn") ||
        target.closest(".btn");

      const isTab =
        target.classList.contains("tab") ||
        target.closest(".tab") ||
        target.classList.contains("nav-link") ||
        target.closest(".nav-link");

      const isInteractiveElement =
        isButton ||
        isTab ||
        target.closest("a.nav-link") ||
        target.closest("[role='tab']") ||
        target.closest("input") ||
        target.closest("label") ||
        target.closest("select") ||
        target.closest("a") ||
        target.closest("[data-ignore-click-outside]") ||
        target.closest('[data-actionable="true"]') ||
        hasPointerCursor(target);

      // NEW: Check if the click is inside a modal or message element
      const isInModalOrMessage =
        target.closest(".modal") ||
        target.closest(".toast") ||
        target.closest(".alert") ||
        target.closest("[role='alert']") ||
        target.closest("[aria-live='polite']");

      const isCancelUploadButton = target.closest("#cancel-upload-button");
      const isInsideDrawer = Boolean(target.closest("#log-overlay-drawer"));
      const isInsideContainer =
        containerRef.current && containerRef.current.contains(target);
      // Check if click is outside the container
      const isOutside = !(
        isInsideContainer ||
        isCancelUploadButton ||
        isInsideDrawer
      );

      if (isOutside && !isInModalOrMessage) {
        if (isInteractiveElement) {
          setShowUploadWarning(true);
        } else {
          setShowUploadWarning(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUploadFile]);

  const handleUploadInteraction = () => {
    setShowUploadWarning(false);
    dispatch(setIsUploadFile(false));
    dispatch(setIsCancelFiles(true));
    setIsAllCancel(true);
  };

  const handleCloseModalWarning = () => {
    setShowUploadWarning(false);
  };

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
    }
    setIsAllCancel(false);
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  useEffect(() => {
    const handleScroll = () => {
      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);

      if (documentType && sender) {
        setrecordInfoKey(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  return (
    <Container fluid className="pb-5" ref={containerRef}>
      <Loader isLoading={loading} />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />

      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id: any) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />

      {recordInfoAccordion([
        {
          title: "Record Information",
          content: (
            <>
              <Row>
                <Col sm={3} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Document Type"
                    name="documentType"
                    required={true}
                    options={documentTypeOptions}
                    value={documentType}
                    onChange={async (e, name, value) => {
                      setDocumentType(value);
                      setComments("");
                      const selectedType = documentTypeOptions?.find(
                        (item) => item.value === value,
                      );
                      if (selectedType) {
                        setDocumentCategory(
                          selectedType?.documentCategory || "",
                        );
                        setDocumentTypeDescription(
                          selectedType?.documentTypeDescription || "",
                        );
                        const dataAppointments =
                          await fetchAppointmentDatesByDocumentType(
                            caseInfoId,
                            Number(value),
                          );
                        setAppointmentDateOptions(dataAppointments ?? []);
                        if (dataAppointments && dataAppointments?.length === 1) {
                          const singleValue = dataAppointments[0]?.value;
                          setAppointmentDateTime(singleValue);
                          if (QME_DOCUMENT_TYPES.includes(documentName)) {
                            fetchQMEProcessData(Number(singleValue));
                          }
                        }
                      }
                    }}
                    disabled={
                      result[0]?.caseRecordHeaderId ||
                      (view_Case &&
                        !isRestirctEdit &&
                        !isEditorOrBillingRole) ||
                      isStageNonEditable
                    }
                  />
                </Col>
                <Col sm={3}>
                  <TextInput
                    label="Category"
                    name="documentCategory"
                    value={documentCategory}
                    disabled
                  />
                </Col>

                <Col sm={6}>
                  <TextInput
                    label="Document Type Description"
                    name="documentTypeDescription"
                    value={documentTypeDescription}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                {existsDocType ? (
                  <Col sm={6}>
                    <TextInput
                      label="Sender"
                      name="sender"
                      value={senderName}
                      disabled
                    />
                  </Col>
                ) : (
                  <Col sm={6} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Sender"
                      name="sender"
                      required={true}
                      options={senderOptions}
                      value={sender}
                      onChange={(e, name, value) => {
                        setSender(value);
                        const selectedCode = senderOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedCode) {
                          setSenderCode(selectedCode?.partyCode || "");
                        }
                      }}
                      disabled={
                        result[0]?.caseRecordHeaderId ||
                        (view_Case &&
                          !isRestirctEdit &&
                          !isEditorOrBillingRole) ||
                        isStageNonEditable
                      }
                    />
                  </Col>
                )}
                <Col sm={6} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Appointment Date & Time"
                    name="ADT"
                    required={true}
                    options={appointmentDateOptions}
                    value={appointmentDateTime}
                    onChange={(e, name, value) => {
                      setAppointmentDateTime(value);
                      if (QME_DOCUMENT_TYPES.includes(documentName)) {
                        fetchQMEProcessData(Number(value));
                      }
                    }}
                    disabled={
                      result[0]?.caseRecordHeaderId ||
                      (view_Case &&
                        !isRestirctEdit &&
                        !isEditorOrBillingRole) ||
                      isStageNonEditable ||
                      !documentType
                    }
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12}>
                  <MultilineTextBox
                    label="Additional Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={300}
                    disabled={
                      (view_Case &&
                        !isRestirctEdit &&
                        !isEditorOrBillingRole) ||
                      isStageNonEditable ||
                      isRORCompleted ||
                      isTranscriptionCompleted
                    }
                  />
                </Col>
              </Row>
            </>
          ),
        },
      ])}

      {documentType && (
        <>
          {" "}
          {attachmentAccordion([
            {
              title: "Attachments",
              content: (
                <>
                  {documentType ? (
                    <Row className="align-items-center">
                      <EditableFileTable
                        caseInfoId={caseInfoId}
                        comments={comments}
                        onFileIdsUpdate={handleFileIdsUpdate}
                        result={result}
                        isCancel={isCancel}
                        documentType={documentType}
                        isRowActionTriggered={isRowActionTriggered}
                        selectedRowData={selectedRowData}
                        recordActiveTab={recordActiveTab}
                        activeTab={activeTab}
                        isAllCancel={isAllCancel}
                        setIsAllCancel={setIsAllCancel}
                        isRestirctEdit={isRestirctEdit}
                        isEditorOrBillingRole={isEditorOrBillingRole}
                        RORStatusDisable={
                          isRORCompleted || isTranscriptionCompleted
                        }
                      />
                    </Row>
                  ) : (
                    ""
                  )}
                </>
              ),
            },
          ])}
        </>
      )}

      {documentName === "Record Review Summary" && appointmentDateTime && (
        <>
          {recordRORAccordion([
            {
              title: "Review of Records",
              content: (
                <>
                  {reviewRecordSummaryResult?.length ? (
                    renderAccordion()
                  ) : (
                    <div>
                      <Row>
                        <span className="no_rec_data">No Record Found</span>
                      </Row>
                    </div>
                  )}
                </>
              ),
            },
          ])}
        </>
      )}

      <Row className="mb-3 mt-3">
        <Col className="d-flex justify-content-start">
          {isEditorFile && (
            <Button
              variant="outline"
              className="d-flex align-items-center btn-text-border me-1"
              onClick={handleBack}
            >
              <span className="material-icons mr-2 ">arrow_back</span>
              Back
            </Button>
          )}
          {userData?.caseInfoId ? (
            <>
              {!isEditorFile && (
                <Button
                  variant="outline"
                  className="d-flex align-items-center btn-text-border me-1"
                  onClick={handleBack}
                >
                  <span className="material-icons mr-2 ">arrow_back</span>
                  Back
                </Button>
              )}
              {isRowActionTriggered ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={
                    <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                      Logs
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center mx-2 me-0"
                    onClick={handleOpenDrawer}
                  >
                    <span className="material-icons">description</span>
                  </button>
                </OverlayTrigger>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </Col>
        <Col className="d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-center m-0"
            onClick={handleCancelButton}
            disabled={
              isSaveDisabled ||
              (view_Case && !isRestirctEdit && !isEditorOrBillingRole) ||
              isStageNonEditable ||
              isOnSaveDisable ||
              isRORCompleted ||
              isTranscriptionCompleted
            }
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="d-flex align-items-center mx-2"
            onClick={handleSubmit}
            disabled={
              isSaveDisabled ||
              (view_Case && !isRestirctEdit && !isEditorOrBillingRole) ||
              isStageNonEditable ||
              isOnSaveDisable ||
              isRORCompleted ||
              isTranscriptionCompleted
            }
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Col>
      </Row>

      <OverlayDrawer
        title={"Logs"}
        open={drawerOpen}
        onClose={handleCloseDrawer}
        placement="bottom"
      >
        <DataTable
          headers={GENERAL_LOG_HEADERS}
          rows={logdata}
          isLogTable={true}
        />
      </OverlayDrawer>

      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        data-ignore-click-outside
        show={showUploadWarning}
        onHide={handleCloseModalWarning}
      >
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            Your files are currently uploading. Cancelling now will discard any
            in-progress uploads. Are you sure?
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalWarning}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            id="cancel-upload-button"
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleUploadInteraction}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default UploadRecords;
